<template>
  <div class="pb-5" >

    <b-row class="m-0 justify-content-center" >
      <div style="width: 1600px; max-width: 100%; " >
        <b-row class="m-0 justify-content-center" >

        <!-- <b-col lg="4" class="p-0 pr-lg-3 d-none d-lg-flex w-100 h-100" style="position: sticky; top: 0px">
            <div class="ml-lg-5 mt-4 p-3 shadow bg-white rounded w-100" style="margin-top: 100px !important">
            
            <b-row class="m-0 justify-content-center">
              <b-img-lazy class="mt-3" :src="require(`@/assets/images/undraw_my_current_location.svg`)" style="height: 150px" fluid alt="eatDorado Logo"></b-img-lazy>
              
              <div style="width: 100%" v-if="!isMobile">
                <google-places-autocomplete/>
              </div>             

              <b-form-group
                class="mt-4"
                style="width: 90%"
                id="input-group-1"
                label="Entfernung:"
                label-for="input-1"
                :description="distance + ' km'"
              >
                <b-form-input v-model="distance" min="1" max="25" class="" type="range" placeholder="Enter your name"></b-form-input>
              </b-form-group>

              <b-form-group
                class="text-center"
                style="width: 100%"
                id="input-group-1"
                label="Bewertung:"
                label-for="input-1"
              >
                  <b-form-rating class="text-center" size="lg" :no-border="true" variant="warning" v-model="rating"></b-form-rating>            
              </b-form-group>

              <b-form-group style="width: 100%">
                <b-form-checkbox
                  class="text-left ml-3"
                  switch size="lg"
                  v-model="enable_online_order"
                >
                  <font-awesome-icon class="mx-2" style="font-size: 20px; position: relative" :icon="['fas', 'mobile']"/> Onlinebestellung
                </b-form-checkbox>
              </b-form-group>

              <b-form-group style="width: 100%">
                <b-form-checkbox
                  class="text-left ml-3"
                  switch size="lg"
                  v-model="delivery"
                >
                  <font-awesome-icon class="mx-2" style="font-size: 20px; position: relative" :icon="['fas', 'car-side']"/> Lieferung
                </b-form-checkbox>
              </b-form-group>
             
              
            </b-row>

            <p class="text-center mt-4">Entdecke Restaurants in Deiner Nähe und somit allerlei Köstlichkeiten</p>
          </div>
        </b-col> -->

        <b-col cols="12" lg="8" class="p-0 h-100" style="z-index: 1000 !important">
          <div class="mt-3 mt-lg-4 shadow bg-white rounded p-3 h-100" style="margin-top: 100px !important">
            <div >
              <h3 class="text-center mb-4">Essen in Oelsnitz/Vogtland</h3>
              <b-row class="m-0 justify-content-center">
                <b-img-lazy :src="require(`@/assets/images/undraw_cooking.svg`)" style="height: 150px" fluid alt="cooking Logo"></b-img-lazy>  
              </b-row>
              <div v-if="company">
                <h3 class="text-center mt-4"><span v-if="filteredRestaurants">{{filteredRestaurants.length}}</span> Restaurant{{filteredRestaurants.length > 1 || filteredRestaurants.length == 0 ? 's' : ''}} in der Nähe:</h3>
              </div>
              
              <div style="z-index: 1000 !important" class="d-none d-lg-block pt-2" v-if="adressData">
                <div v-if="filteredRestaurants.length > 0">
                  <div v-for="restaurant in filteredRestaurants" :key="restaurant.index">
                    <restaurant-regular  :restaurant="restaurant" :city="restaurant.adress.city" :street="restaurant.adress.street" :ratings="restaurant.ratings" :distance="distanceInKmBetweenEarthCoordinates(adressData.latitude, adressData.longitude, restaurant.adress.lat, restaurant.adress.lon)" :rating="restaurant.rating" :url="restaurant._id" :id="restaurant._id" :name="restaurant.title" :img="getImage(restaurant.img.image)" :description="restaurant.description" ></restaurant-regular>
                  </div>
                </div>
                
                <div v-else>
                  <h4 class="text-center my-5">Dein Lieblingsrestaurant ist noch nicht dabei?</h4>
                  <h4 class="text-center my-3">Empfehle eatDorado.de gerne weiter!</h4>
                </div>
              </div>

              <div style="z-index: 1000 !important" class="d-block d-lg-none pt-2" v-if="adressData && company">

                <div v-if="filteredRestaurants.length > 0">
                  <div v-for="restaurant in filteredRestaurants" :key="restaurant.index">
                    <restaurant-regular :restaurant="restaurant"  :city="restaurant.adress.city" :street="restaurant.adress.street" :ratings="restaurant.ratings" :distance="distanceInKmBetweenEarthCoordinates(adressData.latitude, adressData.longitude, restaurant.adress.lat, restaurant.adress.lon)" :rating="restaurant.rating" :url="restaurant._id" :id="restaurant._id" :name="restaurant.title" :img="getImage(restaurant.img.image)" :description="restaurant.description" ></restaurant-regular>
                  </div>
                </div>
                
                <div v-else>
                  <h4 class="text-center my-5">Dein Lieblingsrestaurant ist noch nicht dabei?</h4>
                  <h4 class="text-center my-3">Empfehle eatDorado.de gerne weiter!</h4>
                </div>

              </div>

              <div v-if="!adressData">
                <h4 class="text-center my-5">Bitte gebe deinen Ort in die Suche ein</h4>
              </div>
            </div>

          </div>
        </b-col>      
      </b-row>

      </div>
    </b-row>

    <!-- <div class="d-block d-lg-none shadow bg-white" style="z-index: 3000; position: fixed; bottom: -2px; left: 0; right: 0; transition: all 0.3s ease-in-out; z-index: 3002; height: 100vh" :style="expanded ? 'height: 100%' : 'height: 85px' " v-if="isMobile">
      <b-row class="m-0 py-3 pb-2 linear-warning justify-content-start" style="height: 85px">
        <div style="position: relative"  @click="expanded = !expanded">

            <font-awesome-icon v-if="!expanded" class="ml-3 h1 hover text-dark" :icon="['fas', 'search']"/>
            <font-awesome-icon v-if="expanded" class="ml-3 h1 hover text-dark" :icon="['fas', 'chevron-down']"/>

          <h2 class="m-0 p-0"><b-badge pill variant="info"></b-badge></h2>
        </div>
        <div style="max-width: 80%" class="mt-1">
          <div>
            <b-row class="m-0 ml-5 justify-content-center"  v-show="!expanded">
              <b-form-group class="ml-2 mt-2" style="transform: scale(2)">
                <b-form-checkbox
                    class="text-left ml-2"
                    switch 
                    size="lg"
                    v-model="enable_online_order"
                  >
                    <font-awesome-icon style="font-size: 20px; position: relative" :icon="['fas', 'mobile']"/> 
                  </b-form-checkbox>
                </b-form-group>

                <b-form-group class="mt-2 ml-4" style="transform: scale(2)">
                  <b-form-checkbox
                    class="text-left ml-5"
                    switch 
                    size="lg"
                    v-model="delivery"
                  >
                  <font-awesome-icon style="font-size: 20px; position: relative" :icon="['fas', 'car-side']"/> 
                </b-form-checkbox>
              </b-form-group>
              
            </b-row>
          </div>
          <h4 class="ml-3" v-if="expanded">{{adressData.locality}}</h4>
          
          
        </div>
      </b-row>

      <h3 class="text-center my-4"><span v-if="filteredRestaurants">{{filteredRestaurants.length}}</span> Restaurant{{filteredRestaurants.length > 1 || filteredRestaurants.length == 0 ? 's' : ''}} in Deiner Nähe</h3>
      <b-row class="m-0 justify-content-center">
        <div style="width: 90%">
          <google-places-autocomplete/>
        </div> 
      </b-row>
      
      <div class="mt-5 p-3" style="transform: scale(1.2)">
        
      <b-form-group
        class="mt-4 mx-5"
        id="input-group-1"
        label="Entfernung:"
        label-for="input-1"
        :description="distance + ' Km'"
      >
        <b-form-input v-model="distance" min="1" max="15" class="" type="range" placeholder="Enter your name"></b-form-input>
      </b-form-group>

      <b-form-group
        class="mx-5 mb-4"
        id="input-group-1"
        label="Bewertung:"
        label-for="input-1"
      >
          <b-form-rating class="text-center" size="lg" :no-border="true" variant="warning" v-model="rating"></b-form-rating>            
      </b-form-group>

      
      <b-form-group  style="width: 100%;">
          <b-form-checkbox
            class="text-left mx-5"
            switch 
            size="lg"
            v-model="enable_online_order"
          >
            <font-awesome-icon class="mx-2" style="font-size: 20px; position: relative" :icon="['fas', 'mobile']"/> Onlinebestellung
          </b-form-checkbox>
        </b-form-group>

        <b-form-group style="width: 100%">
          <b-form-checkbox
            class="text-left mx-5"
            switch 
            size="lg"
            v-model="delivery"
          >
            <font-awesome-icon class="mx-2" style="font-size: 20px; position: relative" :icon="['fas', 'car-side']"/> Lieferung
          </b-form-checkbox>
        </b-form-group>
      </div>
    </div> -->
    
    <Footer class="my-5"></Footer>

  </div>
</template>

<script>

import coreData from '@/mixins/coreDataMixin'
import RestaurantRegular from '@/views/components/RestaurantRegular'
import Footer from '@/components/Footer'
// import GooglePlacesAutocomplete from './components/GooglePlacesAutocomplete'
// import axios from 'axios'

export default {
  name: 'Restaurants',
  mixins: [coreData],
  components: {
    RestaurantRegular,
    Footer,
    // GooglePlacesAutocomplete
  },
  data: () => {
    return {
      isMobile: null,
      expanded: false,
      enable_online_order: null,
      delivery: false,
      showDetail: false,
      form: {},
      loginModal: false,
      registerActive: false,
      distance: 15,
      rating: null
    }
  },
  computed: {
    darkMode(){
      return this.$store.getters.darkMode
    },
    filteredRestaurants(){
      var array = []
      if(!this.adressData) return array
      if(this.company){
        
        array = this.company

        if(this.rating){
          array = array.filter(restaurant => this.getRating(restaurant) >= (this.rating - 0.5) || this.rating == 1)
        }

        if(this.enable_online_order){
          array = array.filter(restaurant => restaurant.enable_online_order)
        }

        if(this.delivery){
          array = array.filter(restaurant => restaurant.delivery)
        }

        if(this.distance && this.adressData){
          array = array.filter(restaurant => this.distanceInKmBetweenEarthCoordinates(this.adressData.latitude, this.adressData.longitude, restaurant.adress.lat, restaurant.adress.lon) <= parseInt(this.distance))
        }
      }      

      return array.sort( this.compare );
    }
  },
  mounted(){
    this.$nextTick(function() {
      window.addEventListener('resize', this.getWindowWidth);
      this.getWindowWidth()
    })
    this.getWindowWidth()
    this.getLocation()
  },
  beforeDestroy(){
    window.removeEventListener('resize', this.getWindowWidth);
  },
  methods: {
    getLocation(){
      this.adressData = {country: "Deutschland",latitude:50.4175985,locality:"Oelsnitz/Vogtl., Deutschland",longitude:12.1758073}
      this.$store.commit('adressData', this.adressData)
      // if(this.adressData) return
      // if(!this.$route.query.locality) return
      // axios.get('https://maps.googleapis.com/maps/api/geocode/json?address=germany,' + this.$route.query.locality + '&region=de&key=AIzaSyD_9KM0IcRD81nQUVZKNFVW_d5NEJU3SIM')
      //       .then(
      //         (res) => {

      //             var adressData = {
      //               country: "Deutschland",
      //               latitude: res.data.results[0].geometry.location.lat,
      //               locality: res.data.results[0].formatted_address,
      //               longitude: res.data.results[0].geometry.location.lng,
      //             }
      //             this.$store.dispatch('getCompany')
      //             this.$store.commit('adressData', adressData)

      //             localStorage.setItem('adressData', JSON.stringify(this.adressData))
      //             this.$router.push('/restaurants?locality='+this.location).catch(() => {})
      //             // if(this.$route.name == 'Restaurants'){
      //             //   this.$router.push('/restaurants?locality='+this.location).catch(() => {})
      //             //   window.location.reload()
      //             // }else{
      //             //   this.$router.push('/restaurants?locality='+this.location).catch(() => {})
      //             // }
                  
      //         }
      //       )
      //       .catch(
      //         error => {
      //             console.log(error)
      //       }
      //     )
    },
    getWindowWidth() {
      this.isMobile = document.documentElement.clientWidth < 992 ? true : false
    },
    reloadLocation(){
      window.location.reload()
    },
    compare( a, b ) {
        var vm = this
        var rangeA = vm.distanceInKmBetweenEarthCoordinates(vm.adressData.latitude, vm.adressData.longitude, a.adress.lat, a.adress.lon)
        var rangeB = vm.distanceInKmBetweenEarthCoordinates(vm.adressData.latitude, vm.adressData.longitude, b.adress.lat, b.adress.lon)
        if ( parseInt(rangeA) < parseInt(rangeB) ){
          return -1;
        }
        if ( parseInt(rangeA) > parseInt(rangeB) ){
          return 1;
        }
        return 0;
      },
    login(){
      var payload = {
        email: this.form.email,
        password: this.form.password
      }
      this.$store.dispatch('login', payload)
    },
    getRating(restaurant){
      if(!restaurant.ratings) return 0.0
      var rating = 0.0
      restaurant.ratings.forEach(el => {
        rating += el.rating
      })

      return rating / restaurant.ratings.length
    }
  }
}
</script>